export const classes = {
  wrapper: 'flex flex-col',
  newCommentWrapper:
    'border-t border-solid border-black/[0.055] dark:border-white/[0.05]',
};

export const styles = {
  list: {
    '&': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
};
